var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.a,.b{stroke:#70db7e;stroke-width:4px;}.b,.d{fill:none;}.b{stroke-linecap:round;stroke-linejoin:round;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-969 -209)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(969 209)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 39,
    cy: 39,
    r: 39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 39,
    cy: 39,
    r: 37
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-961.478-8808l9.415,9.415,19.362-19.371",
    transform: "translate(1955.089 9056.271)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.54327aefa97b5835a0021c686aa24042.svg";
export { ForwardRef as ReactComponent };